import { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from './routes'
import { LoginModal } from '@/components/auth/LoginModal'
import { useAuthStore } from '@/stores/auth.store'

export default function App() {
  const initialize = useAuthStore((s) => s.initialize)

  useEffect(() => {
    const unsubscribe = initialize()
    return unsubscribe
  }, [initialize])

  return (
    <>
      <RouterProvider router={router} />
      <LoginModal />
    </>
  )
}
